var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 38,
  height: 32,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M35 30.284H0V2h35z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.857 30.284L35 16.142 20.857 2M35 16.784H0",
  stroke: "#FF4D00",
  strokeWidth: 3
})));

export default SvgIcon;